import {
	REVISION_REQUEST, REVISION_EXPENSES, REVISION_REGISTRY, REVISION_PROFILES, REVISION_OWNER,
	REVISION_INSTANCE, REVISION_FAIL, REVISION_CONCLUSION, REVISION_CONCLUSION_EDIT, REVISION_AGREEMENTS_ADMIN,
	REVISION_AGREEMENTS_ADMIN_EDIT, REVISION_AGREEMENTS_LEGAL, REVISION_AGREEMENTS_LEGAL_EDIT, REVISION_REPORTS_FINANCIAL,
	REVISION_REPORTS_EXPENSES, REVISION_REPORTS_SUMMARY, REVISION_CLEAR, REVISION_COMMISSION,
	REVISION_COMMISSION_CLEAR, REVISION_COMPLETE
} from "../store/config";

const revisionInit = {
	isFetching: false,
	owner: {
		body: undefined,
		phase_slug: undefined
	},
	instance: {
		body: [],
		phase_slug: undefined,
		notification_type_id: undefined
	},
	registry: {
		body: {},
		phase_slug: undefined
	},
	expenses: {
		body: {},
		phase_slug: undefined
	},
	profiles: {
		body: {},
		phase_slug: undefined
	},
	conclusion: {
		body: {},
		phase_slug: undefined,
		notification_type_id: undefined
	},
	commission: {
		spvpu: {},
		projects: {},
		project: {},
		answers: [],
		finished: false,
		comments: undefined,
		revision: undefined
	},
	agreements: {
		admin: {
			body: {},
			phase_slug: undefined,
			notification_type_id: undefined
		},
		legal: {
			body: {},
			phase_slug: undefined,
			notification_type_id: undefined
		}
	},
	reports:{
		financial:{
			notification_type_id: undefined,
			body: {},
			phase_slug: undefined,
			agency:[]
		},
		expenses:{
			notification_type_id: undefined,
			body: {},
			phase_slug: undefined,
			agency:[]
		},
		summary:{
			notification_type_id: undefined,
			body: {},
			phase_slug: undefined
		}
	},
	phase_group: {},
	notifications_types: [],
	permissions:[],
	surveyShow: false,
	error: undefined,
	timestamp: undefined
}

const revision = (state = revisionInit, action) => {
	switch (action.type) {
		case REVISION_OWNER:
			return {
				...state,
				owner: {
					...state.owner,
					...action.payload
				},
				phase_group: action.phase_group,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_INSTANCE:
			return {
				...state,
				instance: {
					...state.instance,
					...action.payload
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_REGISTRY:
			return {
				...state,
				//isFetching: action.isFetching,
				registry: {
					...state.registry,
					/*id: action.payload.id,
					body: action.payload.body,
					phase_slug: action.payload.phase_slug*/
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_PROFILES: {
			return {
				...state,
				//isFetching: action.isFetching,
				profiles: {
					...state.profiles,
					/*id: action.payload.id,
					body: action.payload.body,
					phase_slug: action.payload.phase_slug*/
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		}
		case REVISION_EXPENSES:
			return {
				...state,
				//isFetching: action.isFetching,
				expenses: {
					...state.expenses,
					/*id: action.payload.id,
					body: action.payload.body,
					phase_slug: action.payload.phase_slug*/
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_CONCLUSION:
			return {
				...state,
				//isFetching: action.isFetching,
				conclusion: {
					...state.conclusion,
					/*id: action.payload.id,
					body: action.payload.body,
					phase_slug: action.payload.phase_slug,
					notification_type_id: action.payload.notification_type_id*/
					...action.payload
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_CONCLUSION_EDIT:
			return {
				...state,
				//isFetching: action.isFetching,
				conclusion: {
					...state.conclusion,
					/*id: action.payload.id,
					body: action.payload.body,
					phase_slug: action.payload.phase_slug,
					notification_type_id: action.payload.notification_type_id*/
					...action.payload
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_AGREEMENTS_ADMIN:
			return {
				...state,
				isFetching: action.isFetching,
				agreements: {
					...state.agreements,
					admin: {
						...state.agreements.admin,
						...action.payload
					}
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_AGREEMENTS_ADMIN_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				agreements: {
					...state.agreements,
					admin: {
						...state.agreements.admin,
						...action.payload
					}
				},
				phase_group: action.phase_group,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_AGREEMENTS_LEGAL:
			return {
				...state,
				isFetching: action.isFetching,
				agreements: {
					...state.agreements,
					legal: {
						...state.agreements.legal,
						...action.payload
					}
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_AGREEMENTS_LEGAL_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				agreements: {
					...state.agreements,
					legal: {
						...state.agreements.legal,
						...action.payload
					}
				},
				phase_group: action.phase_group,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_REPORTS_FINANCIAL:
			return {
				...state,
				reports: {
					...state.reports,
					financial: {
						...state.reports.financial,
						...action.payload
					}
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				isFetching: action.isFetching,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_REPORTS_EXPENSES:
			return {
				...state,
				reports: {
					...state.reports,
					expenses: {
						...state.reports.expenses,
						...action.payload
					}
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				isFetching: action.isFetching,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_REPORTS_SUMMARY:
			return {
				...state,
				reports: {
					...state.reports,
					summary: {
						...state.reports.summary,
						...action.payload
					}
				},
				phase_group: action.phase_group,
				notifications_types: action.notifications_types,
				isFetching: action.isFetching,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REVISION_COMMISSION:
			return {
				...state,
				isFetching: action.isFetching,
				commission: {
					...state.commission,
					...action.payload,
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		/*case REVISION_COMMISSION_SAVE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}*/
		case REVISION_COMMISSION_CLEAR:
			return {
				...state,
				isFetching: action.isFetching,
				commission: action.payload,
				timestamp: action.timestamp
			}
		case REVISION_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case REVISION_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case REVISION_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		case REVISION_CLEAR:
			return {
				...state,
				...action.payload,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default revision;


// WEBPACK FOOTER //
// ./src/reducers/revision.js